export default "__VITE_ASSET__Bhn9bHfl__"